import React from 'react';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import style from './BtnBlock.module.scss';

interface IProps {
	onClose: () => void;
	onSaveAndMakeOtherChanges: () => void;
	onSaveAndClose: () => void;
	disabledSave: boolean;
}

export const BtnBlock: React.FC<IProps> = React.memo(
	({ onClose, onSaveAndMakeOtherChanges, onSaveAndClose, disabledSave }) => {
		return (
			<div className={style.container}>
				<Button theme="secondary" onClick={onClose}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button theme="secondary" disabled={disabledSave} onClick={onSaveAndMakeOtherChanges}>
					<Text
						translationNameSpace="form"
						translationKey="saveAndMakeOtherChangesButton"
						asFragment={true}
					/>
				</Button>
				<Button theme="primaryBlue" disabled={disabledSave} onClick={onSaveAndClose}>
					<Text translationNameSpace="form" translationKey="saveAndCloseButton" asFragment={true} />
				</Button>
			</div>
		);
	},
);
